import axios from "axios";
import { formRegEx, formRegExReplacer } from "constant/regex";
import moment from "moment";
import { toast } from "react-toastify";
import { CURRENCY, recordsLimit } from "../constant/constants";

export const apiHeader = (token, isFormData) => {
  const headers = {
    "ngrok-skip-browser-warning": "69420",
    "timezone-offset": moment().utcOffset(),
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return { headers };
};

export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};

export const formatMessageDate = (date) => {
  const messageDate = moment(date);
  const now = moment();

  if (messageDate.isSame(now, "minute")) {
    // If the date is exactly now, show the current time, e.g., 'HH:mm A'
    return now.format("HH:mm A");
  } else if (messageDate.isSame(now, "day")) {
    // If the date is today, use fromNow()
    return messageDate.fromNow();
  } else if (messageDate.isSame(now.subtract(1, "day"), "day")) {
    // If the date is yesterday, use fromNow()
    return messageDate.fromNow();
  } else {
    // Otherwise, show the date in a standard format, e.g., 'MM/DD/YYYY'
    return messageDate.format("MM/DD/YYYY");
  }
};

export const formatDate = (date) => {
  const formdatedDate = moment(date);
  return formdatedDate.format("MM/DD/YYYY");
};

export const formatTime = (time) => {
  const formattedTime = moment(time);
  return formattedTime.format("hh:mm A");
};
export function stripAllHtmlTags(input) {
  return input?.replace(/<[^>]*>?/gm, "");
}

const options = {
  onDownloadProgress: (progressEvent) => {
    const { loaded, total } = progressEvent;
  },
};
export function downloadFileFromUrl(fileUrl, filename) {
  axios
    .get(fileUrl, {
      responseType: "blob",
      ...options,
    })
    .then(function (response) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: response.headers["content-type"],
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    })
    .catch((e) => {});
}

export const scrollToTop = (topVal = 0) => {
  window.scrollTo({
    top: topVal,
    behavior: "smooth",
  });
};

export const formatNumber = (num) => {
  if (num % 1 === 0) {
    return `${CURRENCY}${num?.toLocaleString()}`;
  } else {
    return `${CURRENCY}${num?.toFixed(2)?.toLocaleString()}`;
  }
};

export const bytesToMB = (bytes) => {
  return bytes / (1024 * 1024);
};

export const quillValidateHandler = (
  params,
  toastMessage = "Please fill the home cms field!",
) => {
  let flag = true;
  for (let key in params) {
    const parsedHTML = new DOMParser().parseFromString(
      params[key],
      "text/html",
    );
    const plainText = parsedHTML.body.textContent || "";
    if (plainText?.trim() === "") {
      toast.error(toastMessage);
      flag = false;
      break;
    }
  }
  return flag;
};

export const displayPhoneNumber = (phone, dialCode) => {
  return phone ? `${dialCode}${phone}` : "--";
};

export const validateUrl = (url) => {
  const urlRegex =
    /^(https?:\/\/)([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
  return urlRegex.test(url);
};

export const urlPattern =
  /^(https?:\/\/)(www\.)?([\w-]+\.)+[a-z]{2,6}(\/[\w-]*)*\/?$/;

export const camelCaseToLower = (str) => {
  return str.replace(formRegEx, formRegExReplacer).toLowerCase();
};

export const getYearRange = () => {
  const years = [
    ...Array.from({ length: 3 }).map((_, i) => ({
      label: `${moment().subtract(i, "year").format("YYYY")}`,
      value: `${moment().subtract(i, "year").format("YYYY")}`,
    })),
  ];
  return years;
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const validateNestedParams = (
  params,
  parentKey = "",
  options = { disallowEmptyArray: true },
) => {
  const formatKey = (rawKey) => {
    return rawKey
      .replace(/\[(\d+)\]/g, (_, i) => ` ${parseInt(i) + 1}`) // [0] => 1
      .split(".")
      .map(
        (part) =>
          part
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase()), // capitalize
      )
      .join(" → ");
  };

  if (Array.isArray(params)) {
    if (options.disallowEmptyArray && params.length === 0) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }

    for (let i = 0; i < params.length; i++) {
      const key = `${parentKey}[${i}]`;
      if (!validateNestedParams(params[i], key, options)) return false;
    }
  } else if (typeof params === "object" && params !== null) {
    const keys = Object.keys(params);
    if (keys.length === 0 && parentKey) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }

    for (const key of keys) {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      if (!validateNestedParams(params[key], fullKey, options)) return false;
    }
  } else {
    if (params === "" || params === null || params === undefined) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }
  }

  return true;
};
